import React from 'react';
import { PreviewConfig } from 'wix-rich-content-preview';
import styles from './read-more.scss';
import { ShowMoreButton } from './show-more-button';

type ReadMoreProps = {
  lines?: number;
  showToggle: boolean;
  onPreviewExpand: PreviewConfig['onPreviewExpand'];
};

export const ReadMore: React.FC<ReadMoreProps> = ({
  lines = 3,
  onPreviewExpand,
  children,
  showToggle = true,
}) => {
  const rmContainer = React.createRef<HTMLDivElement>();
  const rmMocker = React.createRef<HTMLDivElement>();
  const [clamped, setClamped] = React.useState(false);

  React.useEffect(() => {
    const height = rmContainer?.current?.clientHeight;
    const originalHeight = rmMocker?.current?.clientHeight;
    if (height && originalHeight) {
      setClamped(originalHeight > height);
    }
  }, [rmContainer.current, rmMocker.current]);

  return (
    <>
      <div
        className={styles.wrapper}
        ref={rmContainer}
        style={{
          WebkitLineClamp: lines,
        }}
      >
        {children}
      </div>
      <div ref={rmMocker} className={styles.calculationWrapper}>
        {children}
      </div>
      {clamped && showToggle && <ShowMoreButton onPreviewExpand={onPreviewExpand} />}
    </>
  );
};
